import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row py-3 pb-0 g-0" }
const _hoisted_2 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_3 = { class: "col-12 py-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " (UB-04 Locators 31 - 34) Occurrence Codes")
  ])
], -1 /* HOISTED */)
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_31A_code",
  for: "referral-31a-code"
}, " 31A Code: ", -1 /* HOISTED */)
const _hoisted_8 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "31a-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_10 = { class: "input-group date datepickerInput" }
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_13 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_32A_code",
  for: "referral-32a-code"
}, " 32A Code: ", -1 /* HOISTED */)
const _hoisted_15 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "32a-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_17 = { class: "input-group date datepickerInput" }
const _hoisted_18 = ["value"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_20 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_33A_code",
  for: "referral-33a-code"
}, " 33A Code: ", -1 /* HOISTED */)
const _hoisted_22 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "33a-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_24 = { class: "input-group date datepickerInput" }
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_27 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_34A_code",
  for: "referral-34a-code"
}, " 34A Code: ", -1 /* HOISTED */)
const _hoisted_29 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "34a-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_31 = { class: "input-group date datepickerInput" }
const _hoisted_32 = ["value"]
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_34 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_31B_code",
  for: "referral-31b-code"
}, " 31B Code: ", -1 /* HOISTED */)
const _hoisted_36 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "31b-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_38 = { class: "input-group date datepickerInput" }
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_41 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_32B_code",
  for: "referral-32b-code"
}, " 32B Code: ", -1 /* HOISTED */)
const _hoisted_43 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "32b-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_45 = { class: "input-group date datepickerInput" }
const _hoisted_46 = ["value"]
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_48 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_33B_code",
  for: "referral-33b-code"
}, " 33B Code: ", -1 /* HOISTED */)
const _hoisted_50 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { for: "33b-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_52 = { class: "input-group date datepickerInput" }
const _hoisted_53 = ["value"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_55 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_34B_code",
  for: "referral-34b-code"
}, " 34B Code: ", -1 /* HOISTED */)
const _hoisted_57 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { for: "34b-date" }, " Date: ", -1 /* HOISTED */)
const _hoisted_59 = { class: "input-group date datepickerInput" }
const _hoisted_60 = ["value"]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_62 = { class: "col-12 py-2" }
const _hoisted_63 = { class: "mt-1" }
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "col-12 col-lg-6 px-4 col-md-12 g-0" }
const _hoisted_67 = { class: "col-12 py-2" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " (UB-04 Locators 35 - 36) Occurrence Span")
  ])
], -1 /* HOISTED */)
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_35A_code",
  for: "referral-35a-code"
}, " 35A Code: ", -1 /* HOISTED */)
const _hoisted_72 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("label", { for: "35a-start-date" }, " Start Date: ", -1 /* HOISTED */)
const _hoisted_74 = { class: "input-group date datepickerInput" }
const _hoisted_75 = ["value"]
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_77 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("label", { for: "35a-end-date" }, " End Date: ", -1 /* HOISTED */)
const _hoisted_79 = { class: "input-group date datepickerInput" }
const _hoisted_80 = ["value"]
const _hoisted_81 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_82 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_36A_code",
  for: "referral-36a-code"
}, " 36A Code: ", -1 /* HOISTED */)
const _hoisted_84 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("label", { for: "36a-start-date" }, " Start Date: ", -1 /* HOISTED */)
const _hoisted_86 = { class: "input-group date datepickerInput" }
const _hoisted_87 = ["value"]
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_89 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { for: "36a-end-date" }, " End Date: ", -1 /* HOISTED */)
const _hoisted_91 = { class: "input-group date datepickerInput" }
const _hoisted_92 = ["value"]
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_94 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_35B_code",
  for: "referral-35b-code"
}, " 35B Code: ", -1 /* HOISTED */)
const _hoisted_96 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { for: "35b-start-date" }, " Start Date: ", -1 /* HOISTED */)
const _hoisted_98 = { class: "input-group date datepickerInput" }
const _hoisted_99 = ["value"]
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_101 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("label", { for: "35b-end-date" }, " End Date: ", -1 /* HOISTED */)
const _hoisted_103 = { class: "input-group date datepickerInput" }
const _hoisted_104 = ["value"]
const _hoisted_105 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_106 = { class: "form-group col-12 col-lg-12 pe-lg-2" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_36B_code",
  for: "referral-36b-code"
}, " 36B Code: ", -1 /* HOISTED */)
const _hoisted_108 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("label", { for: "36b-start-date" }, " Start Date: ", -1 /* HOISTED */)
const _hoisted_110 = { class: "input-group date datepickerInput" }
const _hoisted_111 = ["value"]
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_113 = { class: "form-group col-12 col-lg-12 pe-lg-12" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", { for: "36b-end-date" }, " End Date: ", -1 /* HOISTED */)
const _hoisted_115 = { class: "input-group date datepickerInput" }
const _hoisted_116 = ["value"]
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_118 = { class: "col-12 py-2" }
const _hoisted_119 = { class: "mt-1" }
const _hoisted_120 = { key: 0 }
const _hoisted_121 = { key: 1 }
const _hoisted_122 = { class: "col-12 col-lg-12 px-4 col-md-12 g-0" }
const _hoisted_123 = { class: "col-12 py-2" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "w-100" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("b", { class: "me-2" }, " (UB-04 Locators 18 - 28) Condition Codes")
  ])
], -1 /* HOISTED */)
const _hoisted_125 = { class: "row" }
const _hoisted_126 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_127 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_18_code",
  for: "referral-18-code"
}, " 18: ", -1 /* HOISTED */)
const _hoisted_128 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_19_code",
  for: "referral-19-code"
}, " 19: ", -1 /* HOISTED */)
const _hoisted_130 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_20_code",
  for: "referral-20-code"
}, " 20: ", -1 /* HOISTED */)
const _hoisted_132 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_21_code",
  for: "referral-21-code"
}, " 21: ", -1 /* HOISTED */)
const _hoisted_134 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_22_code",
  for: "referral-22-code"
}, " 22: ", -1 /* HOISTED */)
const _hoisted_136 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_23_code",
  for: "referral-23-code"
}, " 23: ", -1 /* HOISTED */)
const _hoisted_138 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_24_code",
  for: "referral-24-code"
}, " 24: ", -1 /* HOISTED */)
const _hoisted_140 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_25_code",
  for: "referral-25-code"
}, " 25: ", -1 /* HOISTED */)
const _hoisted_142 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_143 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_26_code",
  for: "referral-26-code"
}, " 26: ", -1 /* HOISTED */)
const _hoisted_144 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_145 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_27_code",
  for: "referral-27-code"
}, " 27: ", -1 /* HOISTED */)
const _hoisted_146 = { class: "form-group col-12 col-lg-3 pe-lg-2" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("label", {
  id: "Referral_28_code",
  for: "referral-28-code"
}, " 28: ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: "Additional UB-04 Locators",
    type: "his-section",
    "full-height": false,
    "application-id": _ctx.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_31A_code",
                  name: "referral-31a-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((
                                        _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator31a
                                            .Code
                                    ) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, 
                                        _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator31a
                                            .Code
                                    ]
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("input", {
                        name: "31a-date",
                        type: "text",
                        class: "form-control",
                        autocomplete: "off",
                        value: 
                                                _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                    .Locator31a.Date
                                            ,
                        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11),
                      _hoisted_12
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]),
              (_ctx.showOccurenceCodes)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_32A_code",
                        name: "referral-32a-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator32a
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator32a
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("input", {
                              name: "32a-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator32a.Date
                                                ,
                              onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_18),
                            _hoisted_19
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_33A_code",
                        name: "referral-33a-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator33a
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator33a
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("input", {
                              name: "33a-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator33a.Date
                                                ,
                              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_25),
                            _hoisted_26
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _hoisted_28,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_34A_code",
                        name: "referral-34a-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator34a
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator34a
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("input", {
                              name: "34a-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator34a.Date
                                                ,
                              onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_32),
                            _hoisted_33
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _hoisted_35,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_31B_code",
                        name: "referral-31b-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator31b
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator31b
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("input", {
                              name: "31b-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator31b.Date
                                                ,
                              onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_39),
                            _hoisted_40
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _hoisted_42,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_32B_code",
                        name: "referral-32b-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator32b
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator32b
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_43, [
                      _hoisted_44,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_45, [
                            _createElementVNode("input", {
                              name: "32b-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator32b.Date
                                                ,
                              onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_46),
                            _hoisted_47
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _hoisted_49,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_33B_code",
                        name: "referral-33b-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator33b
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator33b
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _hoisted_51,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("input", {
                              name: "33b-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator33b.Date
                                                ,
                              onChange: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_53),
                            _hoisted_54
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _hoisted_56,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_34B_code",
                        name: "referral-34a-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator34b
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator34b
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _hoisted_58,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_59, [
                            _createElementVNode("input", {
                              name: "34b-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator34b.Date
                                                ,
                              onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_60),
                            _hoisted_61
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("button", {
                    class: "btn btn-xs btn-primary p-1",
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toogleShowOccurenceCode && _ctx.toogleShowOccurenceCode(...args)))
                  }, [
                    (!_ctx.showOccurenceCodes)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_64, "View Occurence Codes"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_65, "Hide Occurence Codes"))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_66, [
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createElementVNode("div", _hoisted_69, [
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_35A_code",
                  name: "referral-35a-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((
                                        _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator35a
                                            .Code
                                    ) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, 
                                        _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator35a
                                            .Code
                                    ]
                ])
              ]),
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_74, [
                      _createElementVNode("input", {
                        name: "35a-start-date",
                        type: "text",
                        class: "form-control",
                        autocomplete: "off",
                        value: 
                                                _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                    .Locator35a.DateFrom
                                            ,
                        onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_75),
                      _hoisted_76
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]),
              _createElementVNode("div", _hoisted_77, [
                _hoisted_78,
                _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_79, [
                      _createElementVNode("input", {
                        name: "35a-end-date",
                        type: "text",
                        class: "form-control",
                        autocomplete: "off",
                        value: 
                                                _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                    .Locator35a.DateThrough
                                            ,
                        onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                      }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_80),
                      _hoisted_81
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]),
              (_ctx.showOccurenceSpan)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_36A_code",
                        name: "referral-36a-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator36a
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator36a
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_84, [
                      _hoisted_85,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_86, [
                            _createElementVNode("input", {
                              name: "36a-start-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36a.DateFrom
                                                ,
                              onChange: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_87),
                            _hoisted_88
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("input", {
                              name: "36a-end-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36a.DateThrough
                                                ,
                              onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_92),
                            _hoisted_93
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                      _hoisted_95,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_35B_code",
                        name: "referral-35b-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator35b
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator35b
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("input", {
                              name: "35b-start-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator35b.DateFrom
                                                ,
                              onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_99),
                            _hoisted_100
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_101, [
                      _hoisted_102,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_103, [
                            _createElementVNode("input", {
                              name: "35b-end-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator35b.DateThrough
                                                ,
                              onChange: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_104),
                            _hoisted_105
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_106, [
                      _hoisted_107,
                      _withDirectives(_createElementVNode("input", {
                        id: "Referral_36B_code",
                        name: "referral-36b-code",
                        class: "form-control",
                        maxlength: "2",
                        placeholder: "Enter code",
                        type: "text",
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator36b
                                                .Code
                                        ) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, 
                                            _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo.Locator36b
                                                .Code
                                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_108, [
                      _hoisted_109,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_110, [
                            _createElementVNode("input", {
                              name: "36b-start-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36b.DateFrom
                                                ,
                              onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_111),
                            _hoisted_112
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ]),
                    _createElementVNode("div", _hoisted_113, [
                      _hoisted_114,
                      _createVNode(_component_DatePicker, { getDate: _ctx.onDateChange }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_115, [
                            _createElementVNode("input", {
                              name: "36b-end-date",
                              type: "text",
                              class: "form-control",
                              autocomplete: "off",
                              value: 
                                                    _ctx.referral.Insurance.AdditionalBillingInfo.UB04AddtionalBillingInfo
                                                        .Locator36b.DateThrough
                                                ,
                              onChange: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args)))
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_116),
                            _hoisted_117
                          ])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["getDate"])
                    ])
                  ], 64 /* STABLE_FRAGMENT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_118, [
                _createElementVNode("div", _hoisted_119, [
                  _createElementVNode("button", {
                    class: "btn btn-xs btn-primary p-1",
                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.toogleShowOccurenceSpan && _ctx.toogleShowOccurenceSpan(...args)))
                  }, [
                    (!_ctx.showOccurenceSpan)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_120, "View Occurence Span"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_121, "Hide Occurence Span"))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_122, [
          _createElementVNode("div", _hoisted_123, [
            _hoisted_124,
            _createElementVNode("div", _hoisted_125, [
              _createElementVNode("div", _hoisted_126, [
                _hoisted_127,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_18_code",
                  name: "referral-18-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code18) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code18]
                ])
              ]),
              _createElementVNode("div", _hoisted_128, [
                _hoisted_129,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_19_code",
                  name: "referral-19-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code19) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code19]
                ])
              ]),
              _createElementVNode("div", _hoisted_130, [
                _hoisted_131,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_20_code",
                  name: "referral-20-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code20) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code20]
                ])
              ]),
              _createElementVNode("div", _hoisted_132, [
                _hoisted_133,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_21_code",
                  name: "referral-21-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code21) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code21]
                ])
              ]),
              _createElementVNode("div", _hoisted_134, [
                _hoisted_135,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_22_code",
                  name: "referral-22-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code22) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code22]
                ])
              ]),
              _createElementVNode("div", _hoisted_136, [
                _hoisted_137,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_23_code",
                  name: "referral-23-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code23) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code23]
                ])
              ]),
              _createElementVNode("div", _hoisted_138, [
                _hoisted_139,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_24_code",
                  name: "referral-24-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code24) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code24]
                ])
              ]),
              _createElementVNode("div", _hoisted_140, [
                _hoisted_141,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_25_code",
                  name: "referral-25-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code25) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code25]
                ])
              ]),
              _createElementVNode("div", _hoisted_142, [
                _hoisted_143,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_26_code",
                  name: "referral-26-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code26) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code26]
                ])
              ]),
              _createElementVNode("div", _hoisted_144, [
                _hoisted_145,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_27_code",
                  name: "referral-27-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code27) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code27]
                ])
              ]),
              _createElementVNode("div", _hoisted_146, [
                _hoisted_147,
                _withDirectives(_createElementVNode("input", {
                  id: "Referral_28_code",
                  name: "referral-28-code",
                  class: "form-control",
                  maxlength: "2",
                  placeholder: "Enter code",
                  type: "text",
                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code28) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.referral.Insurance.AdditionalBillingInfo.PatientConditionCodes.Code28]
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["application-id"]))
}